import { CreatePaymentRequestResp } from "../../interfaces";
import { CreditTxTypeEnum, PurchaseMethodEnum, PurchaseStatusEnum } from "../../models";

// Fake data for development/testing
export const MOCK_PAYMENT_RESPONSE: CreatePaymentRequestResp = {
  checkoutUrl: "https://pay.payos.vn/web/ab0fe73b7c5448dbb363f7ade1326eef",
  qrCode:
    "00020101021238610010A000000727013100069704520117101425090255237310208QRIBFTTA530370454061000005802VN62270823GARTHERCR8NKh0YvQdXYgHC63042B81",
  creditTx: {
    id: "t4Fu0OKbfHCHqyclb7yb",
    creditId: "8NKh0YvQdXYgHCXqV4fW6CwWMM23",
    amount: 2,
    createdAt: new Date("2025-09-02T02:35:58.051Z"),
    updatedAt: new Date("2025-09-02T02:35:58.051Z"),
    type: CreditTxTypeEnum.PURCHASE,
    desc: "Payment for 2 credits via bank_transfer",
    purchaseMeta: {
      linkId: "8NKh0YvQdXYgHCXqV4fW6CwWMM23",
      creditTxId: "t4Fu0OKbfHCHqyclb7yb",
      method: PurchaseMethodEnum.BANK_TRANSFER,
      status: PurchaseStatusEnum.PENDING,
      currency: "VND",
      orderCode: "1756780556726694",
      qrCode:
        "00020101021238610010A000000727013100069704520117101425090255237310208QRIBFTTA530370454061000005802VN62270823GARTHERCR8NKh0YvQdXYgHC63042B81",
      checkoutUrl: "https://pay.payos.vn/web/ab0fe73b7c5448dbb363f7ade1326eef",
      expiresAt: new Date("2025-09-02T02:35:58.051Z"),
      createdAt: new Date("2025-09-02T02:35:58.051Z"),
      updatedAt: new Date("2025-09-02T02:35:58.051Z")
    },
    usageMeta: null,
    referralMeta: null
  }
};
